import Room from './room';
import Building from './building';

import moment, { Moment, Duration } from 'moment';
import { MOMENT_DATE_FORMAT, MOMENT_TIME_DISPLAY_FORMAT, MOMENT_TIME_FORMAT } from '../constants/date_format';

export class Event {
    id: number;
    name: string;
    room?: Room;
    building?: Building;
    timeIn: Moment;
    timeOut: Moment;
    date: Moment;
    eventCrn: string;
    contactName?: string;
    note?: string;
    instanceNote?: string;
    isManagedEvent: boolean;
    hasUnmatchedFunctions: boolean;
    dateUnmatched: Moment;

    constructor(dto: any, rooms: Array<any>, buildings: Array<any>) {
        this.id = dto.id;
        this.name = dto.name;
        this.timeIn = moment(dto.timeIn, MOMENT_TIME_FORMAT);
        this.timeOut = moment(dto.timeOut, MOMENT_TIME_FORMAT);
        this.date = moment(dto.date, MOMENT_DATE_FORMAT);
        this.eventCrn = dto.eventCrn;
        this.contactName = dto.contactName;
        this.note = dto.note;
        this.instanceNote = dto.instanceNote;
        this.isManagedEvent = dto.isManagedEvent;
        this.hasUnmatchedFunctions = dto.hasUnmatchedFunctions;
        this.dateUnmatched = dto.dateUnmatched ? moment(dto.dateUnmatched, MOMENT_DATE_FORMAT) : undefined;

        const room = rooms.find((r) => r.id === dto.roomId);
        this.room = room ?? new Room(room.id, room.name, room.number);

        const building = buildings.find((b) => b.id === dto.buildingId);
        this.building = building ?? new Building(building.id, building.name);
    }
}

export class EventFormState {
    allData: Array<Event>;
    gridData: Array<Event>;

    constructor(dtos: Array<any>, rooms: Array<any>, buildings: Array<any>) {
        this.allData = dtos.map((dto) => new Event(dto, rooms, buildings));
        this.gridData = dtos.map((dto) => new Event(dto, rooms, buildings));
    }

    filterGridData = (filterObject: any) => {
        let filteredData = [...this.allData];
        // TODO: figure out the delay in filter + clearALL does not work
        if (filterObject.eventCrn) filteredData = filteredData.filter((d) => d.eventCrn.toLowerCase().startsWith(filterObject.eventCrn.toLowerCase()));
        if (filterObject.name) filteredData = filteredData.filter((d) => d.name.toLowerCase().includes(filterObject.name.toLowerCase()));
        if (filterObject.contactName) filteredData = filteredData.filter((d) => d.contactName?.toLowerCase().includes(filterObject.contactName.toLowerCase()));
        // if (filterObject.startDate) {
        //     filteredData = filteredData.filter((d) => d.date.isSameOrAfter(moment(filterObject.startDate)));
        //
        //     if (filterObject.endDate) filteredData = filteredData.filter((d) => d.date.isSameOrAfter(moment(filterObject.startDate)) && d.date.isSameOrBefore(moment(filterObject.endDate)));
        // }
        if (filterObject.timeIn) {
            filteredData = filteredData.filter((d) => d.timeIn.isSameOrAfter(moment(filterObject.timeIn !== ':' ? filterObject.timeIn : '00:00', MOMENT_TIME_FORMAT)));
        }
        if (filterObject.timeOut) filteredData = filteredData.filter((d) => d.timeOut.isSameOrBefore(moment(filterObject.timeOut !== ':' ? filterObject.timeOut : '23:59', MOMENT_TIME_FORMAT)));
        // if (filterObject.building) filteredData = filteredData.filter((d) => d.building?.name.toLowerCase().startsWith(filterObject.building?.name.toLowerCase()));
        if (filterObject.room) filteredData = filteredData.filter((d) => d.room?.number.startsWith(filterObject.room));
        if (filterObject.note) filteredData = filteredData.filter((d) => d.note.toLowerCase().includes(filterObject.note.toLowerCase()));
        if (filterObject.instanceNote) filteredData = filteredData.filter((d) => d.instanceNote.toLowerCase().includes(filterObject.instanceNote.toLowerCase()));

        this.gridData = filteredData;
        return filteredData;
    };
}
